
import { Component, Vue, Prop } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class GrowthCamp extends Vue {
  // FAQ 数据（与 seo.ts 中 FAQ JSON-LD 对应）
  faqList = [
    { question: "光华科研院是什么？和大增长营有什么区别？", answer: "光华科研院（光华科学经营研究院）是光华赋能四大生态业务之一，定位为「企业创始人与高管共同学习'用科学经营实现高质量发展'的实践社群」，不是来听一堂课，而是为持续做好企业打好地基。光华科研院创新推出了MaaS（模型即服务）级内容系统、社群型自组织模式、终身制学习与成长，聚合了企业创始人与高管团队、专家导师、高品质校友，通过现场学习、交流分享、案例走访、校友互助、导师指导等方式，持续学习与践行科学经营，打造面向未来的3B领先企业（Business业务视角+BLM经营模型+BSC管理工具）。与大增长营的核心区别：第一，定位不同——大增长营定位为「企业老板的增长必修课」，是一门2天1夜的训战营课程，核心目标是帮助企业找到增长突破口、实现业绩翻一倍，侧重「增长」这一单一主题的深度学习；光华科研院定位为「实践社群」，核心目标是帮助企业建立可持续做好企业经营管理的系统能力，侧重「科学经营体系」的全面学习和持续实践，是一个长期的学习社群而非单一课程。第二，学习周期不同——大增长营是2天1夜的集中学习，一年内可复训；光华科研院是终身制学习，课堂学习终身复训，专属平台内容持续更新，学员一旦加入即可终身享受学习权益。第三，学习方式不同——大增长营主要是课堂集中训战，采用「学练考评赛奖」六步闭环；光华科研院提供七大学习与成长方式：课堂学习（三天两夜，创始人与高管共学，终身复训）、专属平台在线学、专属学习社群、优秀学员实践案例、企业私董会、科学经营年会、专家导师团在线辅导，学习方式更加多元和持续。第四，人群范围不同——大增长营面向企业创始人及核心高管团队，建议老板带高管一起学；光华科研院同样面向企业创始人/老板/董事长和企业高管团队，但更强调「创始人+高管共学」的团队组团形式，建议企业以团队组团形式共同学习，统一战略认知。第五，价格不同——大增长营市场统一售价19800元/人，早鸟价3980元/人；光华科研院价格为3.98万/人，1+3（老板+高管）10万，3人以上加1万/人，科研院的价格更高，但提供的是终身学习权益和更丰富的社群服务。递进关系：大增长营是光华的入门级产品，适合初次接触科学经营的企业老板体验学习；光华科研院是进阶级产品，适合认可科学经营理念、希望系统学习并长期实践的企业创始人和高管团队。" },
    { question: "科研院的七大学习方式是什么？", answer: "光华科研院为学员提供了七大学习与成长方式，形成「课堂+线上+社群+案例+私董会+年会+导师」的全方位学习生态，确保学员能够持续学习、深度实践、不断成长。1.课堂学习——三天两夜，创始人与高管共学，终身复训。这是科研院的核心学习方式，由方永飞老师主讲，围绕科学经营「12349」系统框架进行系统教学，课堂采用创始人与高管共同学习的模式，建议企业以团队组团形式参加，在学习过程中统一战略认知、破除思维壁垒，课堂学习支持终身复训，学员可反复学习，每次都能获得新收获，同时跟进内容更新和案例迭代。2.专属平台在线学——方便复习、巩固、提升，同时不断有更新内容，尤其是案例。科研院为学员提供专属在线学习平台，学员可随时随地进行线上学习，复习巩固课堂内容，学习持续更新的案例和方法论，平台内容不断迭代更新，尤其是优秀学员的实践案例，确保学员能够持续获取最新的知识和经验。3.专属学习社群——交流分享，共同提高。科研院学员可加入专属学习社群，与同频的企业创始人和高管交流分享、共同提高，社群是学员日常交流和互助的平台，学员可在社群中提出经营问题、分享实践经验、对接资源需求，形成高黏度的校友网络。4.优秀学员实践案例——看样学样，加快落地进程，少走弯路、少趟坑。科研院持续收集和整理优秀学员的实践案例，包括成功经验和失败教训，供全体学员学习参考，通过看样学样，学员可以借鉴标杆企业的落地经验，加快自身企业的落地进程，避免重复踩坑，优秀案例还会在专属平台和年会上进行分享。5.企业私董会——走访同学企业，现场把脉问诊、改善。科研院定期组织企业私董会，走访同学企业，由专家导师和同学企业家共同为企业现场把脉问诊、提出改善建议，私董会采用「企业问诊+集体智慧+专家指导」的模式，学员既是受益者也是贡献者，在帮助他人的过程中也提升自己的经营认知。6.科学经营年会——实践评优，优秀创始人、优秀高管经验分享。科研院每年举办科学经营年会，是学员年度汇聚的盛大活动，年会上进行实践评优，评选优秀创始人、优秀高管，邀请获奖学员分享实践经验和落地成果，年会还发布年度趋势洞察，汇聚行业领袖和专家导师，是学员年度学习、交流、链接的重要平台。7.专家导师团——导师在线，疑难杂症随时可对接导师，沟通互动。科研院配备专家导师团，由方永飞老师和各领域实战专家组成，学员在企业经营中遇到疑难杂症，可随时对接导师进行沟通互动，获得专业的指导和建议，导师在线支持确保学员在实践过程中遇到问题能够及时得到解答，避免走弯路。这七大学习方式相互配合，形成了「课堂系统学+线上随时学+社群交流学+案例对标学+私董会实战学+年会集中学+导师随时导」的完整学习闭环，真正实现终身学习、持续成长。" },
    { question: "科研院的价格和学习期限是怎样的？", answer: "光华科研院采用「一次性付费、终身学习」的模式，价格体系清晰，为企业创始人和高管团队提供了高性价比的长期学习平台。价格信息（以最新通知为准）：单人价格3.98万元/人，这是科研院的单人报名价格，适合企业创始人个人参加学习。团队套餐1+3（老板+高管）10万元，这是科研院最推荐的报名方式，适合企业创始人带领3位核心高管共同学习，平均每人2.5万元，比单人报名优惠约37%，团队共同学习的价值在于统一战略认知、破除思维壁垒，让老板和高管在同一套语言和方法论下协同工作。加人价格3人以上加1万元/人，如果企业希望更多高管参加学习，在1+3套餐基础上，每增加1人只需加1万元，进一步降低了团队学习的人均成本。学习期限：终身制，这是光华科研院最核心的特色之一，学员一旦加入，即可享受终身学习权益，包括：课堂终身复训——三天两夜的核心课堂学习支持终身复训，学员可反复参加，每次学习都能获得新收获，同时跟进内容更新和案例迭代；专属平台持续更新——在线学习平台内容持续更新，尤其是优秀学员的实践案例，学员可终身享受平台学习权益；社群终身成员——学员终身属于科研院校友社群，可持续参与社群交流、资源对接、校友互助；私董会和年会参与——学员可持续参与企业私董会和科学经营年会等活动；专家导师团支持——学员可持续享受专家导师团的在线指导和答疑支持。组团建议：科研院强烈建议创始人+高管团队共同学习，企业经营不是老板一个人的事，战略落地需要核心高管团队的同频共识，老板单独学习后，往往面临「老板学了但中层听不懂、基层不会干」的困境，战略意图传不到一线，团队共同学习可以让老板和高管在课堂上就达成战略共识，回到企业后能够协同推进落地，大幅提升学习转化率。与其他产品的价格对比：科研院3.98万/人的价格，介于大增长营（早鸟3980元/人）和共创会EMBA（咨询报价）之间，但科研院提供的是终身学习权益，从长期来看性价比极高，如果用学习券兑换，光华科研院需要88张学习券/人。以上价格来自光华赋能《产品手册2026》官方画册，实际价格以最新通知为准，报名前请咨询课程顾问确认。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "科研院 | 企业创始人与高管共同学习科学经营的实践社群 - 光华赋能",
      description:
        "光华科学经营研究院（科研院）是企业创始人与高管共同学习用科学经营实现高质量发展的实践社群。通过课堂共学、企业私董会、对标管理工具，帮助企业破解成长瓶颈。",
      keywords:
        "科研院,科学经营研究院,企业创始人培训,高管学习社群,BLM,BSC,企业对标管理,光华赋能",
      path: "/research-institute",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "BLM科学经营" },
        { name: "科研院" }
      ],
      jsonLd: getServiceJsonLd({
        name: "光华科学经营研究院",
        description:
          "企业创始人与高管共同学习用科学经营实现高质量发展的实践社群，提供课堂共学、私董会、对标管理等服务。",
        category: "高管学习社群"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/9b34cdaddc94102ffb5d686c169d3bee.png";
  pic2 = "/img/bf11863009c67736f60aa23af63ff374.png";
  pic3 = "/img/d80616f61491c2219103b802a7c9f29a.png";
  companyArr: any = [];
  List = [
    { title: "BLM科学经营", url: "" },
    { title: "科研院", url: "" }
  ];
  created() {
    this.initData();
  }
  initData() {
    // let companyArr0 = [];
    // let companyArr1 = [];
    // console.log(123456);
    // for (let index = 1; index < 13; index++) {
    //   companyArr0.push({
    //     img: require("@/assets/big-grow-activity/big-grow-activity" +
    //       index +
    //       ".png")
    //   });
    // }
    // for (let index = 13; index < 25; index++) {
    //   companyArr1.push({
    //     img: require("@/assets/big-grow-activity/big-grow-activity" +
    //       index +
    //       ".png")
    //   });
    // }
    // this.companyArr.push(companyArr0);
    // this.companyArr.push(companyArr1);
    // console.log("companyArr", this.companyArr);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute("content", "BLM科学经营，大增长营，科研院");
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "以“科学经营”系统理论为底座，围绕企业高质量发展的核心，基于企业战略规划而设计学习方案，以终为始，有效学习，集中力量，高效学习，统一团队科学经营主线，助力企业力出一孔；BSC，BSC平衡积分卡，分拆对，业务视角、领导力，价值观，分目标，拆动作，对能力，差距分析，战略意图，市场洞察，创新焦点，业务设计，关键任务，正式组织，人才，市场结果，财务，客户，内部流程，学习与成长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
